const wsProto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
export const WS_URL = process.env.REACT_APP_ADMIN_WS_URL || `${wsProto}//${window.location.host}/ws`;

let ws;
const listeners = new Set();

export function connectWebSocket() {
  if (ws) return;

  const token = localStorage.getItem('token');
  if (!token) {
    console.warn("⚠️ No token available for WebSocket connection");
    return;
  }

  const wsUrlWithToken = `${WS_URL}?token=${token}`;
  ws = new WebSocket(wsUrlWithToken);

  ws.onopen = () => console.log("🔌 WebSocket connected");
  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      listeners.forEach(fn => fn(data));
    } catch (e) {
      console.error("Invalid WS message", e);
    }
  };

  ws.onclose = () => {
    console.log("⚠️ WebSocket disconnected. Reconnecting in 3s...");
    ws = null;
    setTimeout(connectWebSocket, 3000);
  };

  ws.onerror = (error) => {
    console.error("WebSocket error:", error);
  };
}

export function disconnectWebSocket() {
  if (ws) {
    ws.close();
    ws = null;
  }
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
